import React from 'react';
import { Control, actions } from 'react-redux-form';
import PropTypes from 'prop-types';
import { currencyFormatter } from '../../../utils/formatters';
import { reportFieldEngagement } from '../../../bootstrap';
import { bindKeyboardEvents } from '../../../common/keyboardHandlers';
import { reportErrorLogs } from '../../../utils/reportErrorLogs';
/*eslint-disable react/no-multi-comp,react/no-danger*/

const SelectedWrapper = (props) => {
  let inputProps = Object.assign({}, props);
  delete inputProps.children;
  delete inputProps.submitted;
  delete inputProps.touched;
  delete inputProps.modelValue;

  const hasValue =
    props.autoFocus &&
    (props.submitted || (props.modelValue === props.htmlFor && props.touched));

  let optimizeImageurl =
    props.imageurl !== null
      ? props.imageurl +
        '?background=transparent&size=' +
        (props.imagesize || 'small')
      : '';

  return (
    <label
      htmlFor={props.htmlFor}
      tabIndex="0"
      className={hasValue ? 'selected' : null}
      onKeyDown={bindKeyboardEvents(props.onClick)}
    >
      {props.imageurl == null ? (
        <div className="defaultImage" alt="" aria-hidden="true" />
      ) : (
        <img
          src={optimizeImageurl}
          className="modelContinueIcon"
          alt=""
          aria-hidden="true"
        />
      )}
      <input {...inputProps} />
      {props.children}
    </label>
  );
};

SelectedWrapper.propTypes = {
  htmlFor: PropTypes.number,
  autoFocus: PropTypes.bool,
  submitted: PropTypes.bool,
  children: PropTypes.array,
  modelValue: PropTypes.number,
  touched: PropTypes.bool,
  imageurl: PropTypes.string,
  imagesize: PropTypes.string,
};

class vehicleModelDiv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagesize: props.parentProps.step.imagesize,
    };
  }
  render() {
    let { fetchedVehicleModels, selectedVehicleYear } = this.props;

    // PHX-7148: Log VehicleModel render state
    const logData = {
      hasModels: !!(fetchedVehicleModels && fetchedVehicleModels.length),
      modelsCount: fetchedVehicleModels ? fetchedVehicleModels.length : 0,
      selectedVehicleYear,
      userAgent: navigator.userAgent,
      isAndroid: /Android/i.test(navigator.userAgent),
      formId: this.props.parentProps.formMeta?.formId,
      formUuid: this.props.parentProps.formMeta?.formUuid,
      clickSessionId: this.props.formMeta?.clickSessionId,
      currentFormData: {
        VehicleMake: this.props.parentProps.formData?.VehicleMake,
        VehicleMakeId: this.props.parentProps.formData?.VehicleMakeId,
        VehicleYear: this.props.parentProps.formData?.VehicleYear,
        AutomobileLoanType: this.props.parentProps.formData?.AutomobileLoanType,
        AutomobileLoanSubType: this.props.parentProps.formData?.AutomobileLoanSubType
      }
    };

    if (!fetchedVehicleModels || fetchedVehicleModels.length === 0) {
      reportErrorLogs('No VehicleModels available for rendering', {
        ...logData,
        criticalIssue: 'No VehicleModels available',
        fetchedVehicleModelsType: typeof fetchedVehicleModels,
        fetchedVehicleModelsValue: fetchedVehicleModels
      });
    } else {
      reportErrorLogs('VehicleModels found and ready for rendering', logData);
    }

    return (
      <div aria-label="Input Container for Vehicle Model">
        {(fetchedVehicleModels &&
          fetchedVehicleModels.length &&
          fetchedVehicleModels.map((item) => (
            <div
              key={item.model.modelId}
              className={`ltFormVehicleModelControl ltFormVehicleModelControl${
                item.model.modelId
              } ${
                this.props.parentProps.formData.AutomobileLoanType !==
                'NewCarPurchase'
                  ? 'vehicleUsedModel'
                  : ''
              }`}
            >
              <Control.radio
                name={item.model.modelName}
                id={item.model.modelId}
                model={`formData.VehicleModelId`}
                className={`ltFormRadioButton ${item.model.modelName}${
                  window.LT5theme === true ? ' ltFormRadioIcon' : ''
                }`}
                component={SelectedWrapper}
                value={item.model.modelName}
                changeAction={(model, value, event) => (dispatch) => {
                  if (event && value !== event.currentValue) {
                    return;
                  }
                  reportFieldEngagement('VehicleModel', item.model.modelName);
                  dispatch(
                    actions.change(
                      `formData.VehicleModel`,
                      item.model.modelName
                    )
                  );
                  dispatch(actions.change(model, item.model.modelId));
                  this.props.parentProps.handleNext();
                }}
                mapProps={{
                  autoFocus: (props) => props.modelValue === item.model.modelId,
                  htmlFor: item.model.modelId,
                  imageurl: item.imageUrl,
                  submitted: ({ fieldValue }) => fieldValue.submitted,
                  modelValue: (props) => props.modelValue,
                  touched: ({ fieldValue }) => fieldValue.touched,
                  onClick: (props) => () => {
                    if (props.value === props.controlProps.value) {
                      props.dispatch(actions.setTouched(props.model));
                      props.dispatch(
                        props.changeAction(props.model, props.value, {
                          currentValue: props.controlProps.value,
                        })
                      );
                    }
                  },
                  imagesize: this.state.imagesize,
                }}
              >
                <div
                  className="labelText"
                  dangerouslySetInnerHTML={{ __html: item.model.modelName }}
                />
                <div className="labelSubText">
                  {this.props.parentProps.formData.AutomobileLoanType ===
                    'NewCarPurchase' && item.evaluation.msrp !== 0 ? (
                    <div>starting at</div>
                  ) : null}
                </div>
                <div className="msrpText">
                  {this.props.parentProps.formData.AutomobileLoanType ===
                    'NewCarPurchase' && item.evaluation.msrp !== 0 ? (
                    <div>
                      {currencyFormatter(item.evaluation.msrp)}
                      <span className="labelSubText"> MSRP</span>
                    </div>
                  ) : null}
                </div>
              </Control.radio>
            </div>
          ))) ||
          (!isNaN(parseInt(selectedVehicleYear)) && (
            <div className="VehicleModelsNotFound">
              We're having trouble finding models for that year, please choose a
              different year
            </div>
          ))}
      </div>
    );
  }
}

/*eslint-enable */
vehicleModelDiv.propTypes = {
  handleNext: PropTypes.func,
  fieldValue: PropTypes.object,
  modelValue: PropTypes.object,
  controlProps: PropTypes.object,
  value: PropTypes.string,
  model: PropTypes.object,
  changeAction: PropTypes.func,
  fetchedVehicleModels: PropTypes.array,
  parentProps: PropTypes.object,
};
export default vehicleModelDiv;
